import createTypeStyleVariant from './createTypeStyleVariant'

/** @component */
export default createTypeStyleVariant('body-1')
